import { Component } from '@theme/component';
import { sectionRenderer } from '@theme/section-renderer';
import { RecentlyViewed } from '@theme/recently-viewed-products';

class RecentlyViewedProductsSection extends Component {
  /** @type {AbortController | null} */
  #activeFetch = null;

  connectedCallback() {
    super.connectedCallback();
    this.#loadProducts();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#activeFetch?.abort();
  }

  /**
   * @returns {string[]}
   */
  #getViewedProductIds() {
    const maxProducts = Number.parseInt(this.dataset.maxProducts || '4', 10);
    const currentProductId = String(this.dataset.productId || '');

    return RecentlyViewed.getProducts()
      .map((/** @type {string} */ id) => String(id))
      .filter((id) => id !== currentProductId)
      .slice(0, maxProducts);
  }

  #loadProducts() {
    const { sectionId, loaded } = this.dataset;

    if (!sectionId || loaded === 'true') return;

    const viewedProducts = this.#getViewedProductIds();

    if (viewedProducts.length === 0) {
      this.#hideSection();
      return;
    }

    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set('q', viewedProducts.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('type', 'product');

    this.#activeFetch?.abort();
    this.#activeFetch = new AbortController();

    sectionRenderer
      .renderSection(sectionId, {
        cache: false,
        url,
        mode: 'full',
      })
      .then(() => {
        if (this.#activeFetch?.signal.aborted) return;

        const element = document.getElementById(`recently-viewed-products-${sectionId}`) ?? this;
        const hasItems = element.querySelector('.resource-list__item') != null;

        if (hasItems) {
          element.dataset.loaded = 'true';
          element.classList.remove('hidden', 'recently-viewed-products--loading');
        } else {
          this.#hideSection();
        }
      })
      .catch(() => {
        if (this.#activeFetch?.signal.aborted) return;
        this.#hideSection();
      })
      .finally(() => {
        this.#activeFetch = null;
      });
  }

  #hideSection() {
    this.classList.add('hidden');
    this.classList.remove('recently-viewed-products--loading');
    this.dataset.loaded = 'true';
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProductsSection);
}
